






























































import { Component, Vue, Watch } from 'vue-property-decorator';
import UserMenu from '@/components/UserMenu.vue';
import Snackbar from '@/components/molecules/Snackbar.vue';
import ImageView from '@/components/annotate/ImageView.vue';
import { annotationModule, authModule } from '@/store';
import AnnotationTab from '@/components/annotate/AnnotationTab.vue';
import { NavigationGuardNext, RawLocation, Route } from 'vue-router';
import DialogContainer from '@/components/dialogs/DialogContainer.vue';
@Component({
  components: { UserMenu, Snackbar, ImageView, AnnotationTab, DialogContainer },
  beforeRouteEnter: (to: Route, from: Route, next: NavigationGuardNext) => {
    next((vm) => {
      if (from.name) {
        vm.$set(vm, 'from', from);
      }
    });
  }
})
export default class Annotate extends Vue {
  from: RawLocation = { name: 'Home' };

  @Watch('$route.params.id')
  bindSeg() {
    const id = this.$route.params.id;
    annotationModule.bindSeg({ id });
  }

  bindSegs() {
    annotationModule.bindCollection();
  }

  get id() {
    return this.$route.params.id;
  }

  get seg() {
    return annotationModule.seg;
  }

  get title() {
    return `${this.seg.index}  ${this.seg.metadata[4]}`;
  }

  get currentUser() {
    return authModule.currentUser;
  }

  get watched() {
    const currentUser = authModule.currentUser;
    return (
      currentUser &&
      annotationModule.watch &&
      annotationModule.watch.uids &&
      annotationModule.watch.uids[currentUser.uid]
    );
  }

  jumpNext() {
    const nextSeg = annotationModule.nextSeg;
    if (nextSeg) {
      this.$router.push({ params: { id: nextSeg.id } });
    }
  }

  jumpPrev() {
    const prevSeg = annotationModule.prevSeg;
    if (prevSeg) {
      this.$router.push({ params: { id: prevSeg.id } });
    }
  }

  openTwitter() {
    const base = 'https://twitter.com/intent/tweet';
    const text = `『${this.title}』｜みんなで古写真【渋沢栄一伝記資料】`;
    const hashtags = '渋沢栄一,渋沢栄一フォトグラフ';
    const url = 'https://denkiphoto.shibusawa.or.jp' + window.location.pathname;
    const link = `${base}?text=${encodeURI(
      text
    )}&hashtags=${hashtags}&url=${url}`;
    window.open(link, '_blank');
  }

  async toggleWatch() {
    await annotationModule.toggleWatch();
  }

  back() {
    this.$router.push(this.from);
  }

  async mounted() {
    await this.bindSeg();
    await this.bindSegs();
  }
}
